import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import PopoverIcon from '../../../Popover/PopoverIconDark';

export interface Props {
  content: React.JSX.Element;
}

const PopoverContent: React.FC<Props> = ({ content }) => (
  <div
    className={clsx(
      'absolute w-60 p-2 bg-gray-700 text-sm z-10',
      'ml-[-5rem] mt-2 rounded-md text-gray-800',
      'shadow-[0px_6px_20px_-2px_rgba(26,26,26,0.14),0px_4px_6px_rgba(26,26,26,0.06)]',
    )}
  >
    <div className="absolute left-28 top-[-7px]">
      <PopoverIcon />
    </div>
    {content}
  </div>
);

export default observer(PopoverContent);
